import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb, BreadcrumbItem } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const RoutesWithCrumbs = ({ Component, routePathList = {} }) => {
  const createCrumbs = useCallback(dictionary => {
    const cr = [];

    if (dictionary) {
      Object.entries(dictionary).forEach(item => {
        const [key, value] = item;

        if (!window.location.pathname.includes(key)) {
          return;
        }

        cr.push({ path: key, name: value });
      });
    }

    return cr;
  }, [routePathList]);

  const crumbs = useMemo(() => createCrumbs(routePathList), [routePathList]);

  return crumbs.length <= 1 ? ( // Don't display single crumbs
    <Component />
  ) : (
    <>
      <Breadcrumb bsPrefix="breadcrumb page-breadcrumb" as="div">
        {/* Link back up the breadcrumb trail */}
        {crumbs.map(({ name, path }, key) => (key + 1 === crumbs.length ? (
          <BreadcrumbItem key={`bci_${key.toString()}`} active>{name}</BreadcrumbItem>
        ) : (
          <BreadcrumbItem key={`bci_${key.toString()}`} linkProps={{ to: path }} linkAs={Link}>
            {name}
          </BreadcrumbItem>
        )))}
      </Breadcrumb>
      <Component />
    </>
  );
};

RoutesWithCrumbs.propTypes = {
  routePathList: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    path: PropTypes.string,
    breadcrumbPath: PropTypes.string,
  }),
  Component: PropTypes.elementType.isRequired,
  matchUrl: PropTypes.shape({
    includes: PropTypes.func,
  }),
};

export default RoutesWithCrumbs;
